<template>
  <v-card class="bg-white shadow rounded px-2 pt-2 pb-4 border border-white" v-if="tarjetaVisible"
    :style="ObtenerValidacionAutorizado(tarjeta)">
    <div class="divide-y-4 divide-opacity-100" :class="manejarEstatus(tarjeta['Estatus'])">
      <div class="flex justify-between">
        <div v-for="(item, index) in informacion" :key="index">
          <vs-tooltip v-if="index == 0" position="right" :text="obtenerTooltip(tarjeta[item])">
            <v-icon :color="obtenerColor(tarjeta[item])">{{ obtenerIcono(tarjeta[item]) }}</v-icon>
          </vs-tooltip>
          <span v-if="index == 1" :class="{ 'font-medium': index == 0, 'text-indigo-700': index == 1 }"
            class="md:text-xs">{{ tarjeta[item] }}</span>
        </div>
      </div>
      <div>
        <v-card :id="tarjeta.ClaveTar" class="overflow-hidden mx-1 mb-1">
          <v-card-text class="pa-0">
            <div class="flex justify-between">
              <div v-for="(item, index) in encabezado" :key="index">
                <span v-if="index == 0" @click="redireccionarPorReporte(tarjeta[item])"
                  :class="{ 'font-medium': index == 0, 'text-indigo-800': index == 0 }"
                  class="md:text-sm truncate md:overflow-clip cursor-pointer ">{{ tarjeta[item] }}</span>
                <span v-if="index == 1" :class="{ 'font-medium': index == 1, 'text-gray-600': index == 1 }"
                  class="md:text-xs" position="right">{{ tarjeta[item] }}</span>
              </div>
            </div>
          </v-card-text>
          <v-card-text class="pa-5 pb-0">
            <div class="grid grid-flow-row auto-rows-max md:auto-rows-1 space-y-2">
              <div v-for="(item, index) in cuerpo" :key="index">
                <div v-if="index == 0 && tarjeta[item].toString() != '0'">
                  <span :class="{ 'font-medium': index == 0 }" class="md:text-xs truncate md:overflow-clip">Num.Eco:
                    {{ tarjeta[item] }}</span>
                </div>
                <div v-if="index != 0">
                  <span :class="{ 'font-medium': index == 0 }"
                    class="md:text-xs truncate md:overflow-clip">{{ tarjeta[item] }}</span>
                </div>

              </div>
            </div>
          </v-card-text>

          <div class="pa-2 flex justify-between">
            <div class="grid grid-flow-col auto-cols-max md:auto-cols-1  space-x-2">
              <div v-for="(item, index) in footer" :key="index">

                <vs-tooltip v-if="index == 0 && tarjeta[item] > 0" position="right" :text="tarjeta[footer[4]]">
                  <v-icon :color="tarjeta[footer[3]]">mdi-bookmark</v-icon>
                </vs-tooltip>
                <vs-tooltip v-if="index == 2 && tarjeta[item] == 1" position="right" :text="'Negociación Pendiente'">
                  <v-icon :color="'#FC2B24'">mdi-briefcase</v-icon>
                </vs-tooltip>
                <span v-if="index == 1" :class="{ 'text-gray-500': index == 0 }"
                  class="md:text-xs truncate md:overflow-clip">{{ tarjeta[item] }}</span>
                <!--<vs-tooltip  v-if="index==2 &&  tarjeta[item]==0"  position="right" :text="'Conductor Detenido'">
                 <v-icon :color="'#FC2B24'">mdi-account-alert</v-icon>
                </vs-tooltip>-->
                <vs-tooltip v-if="index == 3" position="right" :text="tarjeta[footer[6]]">
                  <v-icon color="primary">{{ tarjeta[footer[5]] }}</v-icon>
                </vs-tooltip>
                <vs-tooltip v-if="index == 4" position="right" :text="tarjeta[footer[8]]">
                  <v-icon color="success">{{ tarjeta[footer[7]] }}</v-icon>
                </vs-tooltip>
              </div>
            </div>
          </div>

          <div class="pa-2 pt-0" position="left" style="position: inherit; text-align: end;">
            <div v-for="(item, index) in encabezado" :key="index">
              <vs-tooltip v-if="index == 0" position="right" :text="'Ingresa Seguimiento'">
                <v-icon v-if="tarjeta.Seguimiento" x-large class="task-circle ml-1"
                  :color="'success'">mdi-circle-medium</v-icon>
                <v-icon :color="'#B3C9F1'"
                  @click="redireccionarMovimiento(tarjeta[item], tarjeta.ceclave), tarjeta.Seguimiento = 1">{{ 'mdi-file-document-edit' }}</v-icon>
              </vs-tooltip>
            </div>
          </div>
        </v-card>
      </div>
    </div>
    <div class="centerx">
      <vs-popup title="Redireccionar" :active.sync="alert">
        <p style="text-align: center">
          <v-btn class="ma-2" @click="redirec()" color="blue" dark> Ir <v-icon dark
              right>mdi-table-search</v-icon></v-btn>
        </p>
      </vs-popup>
    </div>
    <!-- </div> -->
  </v-card>

</template>
<script>
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
import { mapState } from 'vuex';
export default {
  props: ['tarjeta'],
  data() {
    return {
      informacion: [],
      encabezado: [],
      cuerpo: [],
      footer: [],
      ceclave: [],
      alert: false,
      url: "",
      valida: "",
    }
  },
  computed: {
    ...mapState(['domain']),
    badgeColor() {
      const mappings = {
        Design: "purple",
        "Feature Request": "teal",
        Backend: "blue",
        QA: "green",
        default: "teal"
      };
      return mappings.default;
    },
    tarjetaVisible() {
      let diferencia = false;
      if (typeof this.tarjeta['FechaMostrar'] == 'string') {
        let fechaFinal = this.$moment(this.tarjeta['FechaMostrar'].toString(), "YYYY-MM-DD");
        let fechaActual = this.$moment().format("YYYY-MM-DD");
        diferencia = this.$moment(fechaFinal, "YYYY-MM-DD").diff(fechaActual, 'days');
        return diferencia <= 0 ? true : false;
      } else {
        return true;
      }
    }
  },
  methods: {
    manejarEstatus(estatus) {
      let temp = {};
      switch (estatus) {
        case 1:
          temp = { 'divide-gray-400': 1 }
          break;
        case 2:
          temp = { 'divide-green-500': 2 }
          break;
        case 3:
          temp = { 'divide-yellow-200': 3 }
          break;
        case 4:
          temp = { 'divide-yellow-400': 4 }
          break;
        case 5:
          temp = { 'divide-red-500': 5 }
          break;
      }
      return temp;
    },
    obtenerTooltip(tipo) {
      let temp;
      switch (tipo) {
        case 'Lib. Fis.':
          temp = 'Liberación Fisica'
          break;
        case 'Lib. Jur.':
          temp = 'Liberación Jurídica'
          break;
        case 'Robo':
          temp = 'Robo'
          break;
      }
      return temp;
    },
    obtenerColor(tipo) {
      let temp;
      switch (tipo) {
        case 'Lib. Fis.':
          temp = '#8e44ad'
          break;
        case 'Lib. Jur.':
          temp = '#f39c12'
          break;
        case 'Robo':
          temp = '#0A0A0A'
          break;
      }
      return temp;
    },
    obtenerIcono(tipo) {
      let temp;
      switch (tipo) {
        case 'Lib. Fis.':
          temp = 'mdi-car'
          break;
        case 'Lib. Jur.':
          temp = 'mdi-car-traction-control'
          break;
        case 'Robo':
          temp = 'mdi-car-off'
          break;
      }
      return temp;
    },

    redirec() {
      window.open(this.url, '_blank');
      this.alert = false
    },
    async redireccionarPorReporte(data) {
      var formData = new FormData();
      formData.append("nrreporte", data.split('-')[0]);
      formData.append("svindice", data.split('-')[1]);
      this.axios.post(`${this.domain.domainNameForApi}Tablero/EstructuraURL`, formData).then(async response => {

        let reporte = {
          nrreporte: data.split('-')[0],
          svindice: data.split('-')[1],
          aiclave: response.data[0].aiclave,
          svfhconclusion: ''
        };
        let routerName = MetodosGenerales.obtenerRouterName(response.data[0].aiclave.toString());
        await MetodosGenerales.guardarEnSesionInfoReporte(reporte, 'reporte');


        let asistenciaurl = await MetodosGenerales.ObtenerURL(reporte);


        let url = this.$router.resolve({ path: asistenciaurl + '/ReporteDetalle' });

        window.open(url.href, '_blank');



      });
    },
    redireccionarMovimiento(data, ceclave) {

      var formData = new FormData();
      formData.append("nrreporte", data.split('-')[0]);
      formData.append("svindice", data.split('-')[1]);
      this.axios.post(`${this.domain.domainNameForApi}Tablero/EstructuraURL`, formData).then(async response => {

        var toToken = {
          nrreporte: response.data[0].nrreporte,
          svindice: response.data[0].svindice,
          aiclave: response.data[0].aiclave,
          claveMovimiento: ceclave,
          respuesta: 0,
        };
        let reporte = {
          nrreporte: response.data[0].nrreporte,
          svindice: response.data[0].svindice,
          aiclave: response.data[0].aiclave,
          svfhconclusion: ''
        };
        await MetodosGenerales.guardarEnSesionInfoReporte(reporte, 'reporte');
        let token = MetodosGenerales.generateJsonToken(toToken);

        let currentRouteFormatted = '';
        if (response.data[0].aiclave == 1) {
          currentRouteFormatted = 'ExpJur'
        }
        else if (response.data[0].aiclave == 24) {
          currentRouteFormatted = 'Robo'
        }
        else if (response.data[0].aiclave == 23) {
          currentRouteFormatted = 'RLV'
        }
        else if (response.data[0].aiclave == 5) {
          currentRouteFormatted = 'RCMedico'
        }
        else if (response.data[0].aiclave == 26) {
          currentRouteFormatted = 'GestoriaDocumental'
        }

        let movimientoRoute =
          this.domain.domainName + "/" + currentRouteFormatted + "/AgregarMovimientos/" + token;

        let url = this.$router.resolve({
          path: movimientoRoute,
          params: {
            tokenData: token,
          },
        });

        window.open(url.href, '_blank');


      });


    },
    ObtenerValidacionAutorizado(data) {

      var formData = new FormData();
      if (data["ceclave"] == 535) {
        formData.append("nrreporte", data["Dato1E"].split('-')[0]);
        formData.append("svindice", data["Dato1E"].split('-')[1]);
        formData.append("ceclave", data["ceclave"]);
        this.axios.post(`${this.domain.domainNameForApi}Tablero/ValidaColumna`, formData).then(response => {

          var data = response.data;
          if (data[0].Column1 == 0)
            this.valida = 'border: 1px solid red;';
          else {
            this.valida = '';
          }
        });
        return this.valida;
      }
    }
  },
  mounted() {

    let temp = Object.keys(this.tarjeta);
    this.informacion = temp.filter(item => item.startsWith('Dato') && item.endsWith('I')).sort();
    this.encabezado = temp.filter(item => item.startsWith('Dato') && item.endsWith('E')).sort();
    this.cuerpo = temp.filter(item => item.startsWith('Dato') && item.endsWith('C')).sort();
    this.footer = temp.filter(item => item.startsWith('Dato') && item.endsWith('F')).sort();
    if (document.getElementById(this.tarjeta.ClaveTar)) {
      document.getElementById(this.tarjeta.ClaveTar).classList.remove("con-vs-card");
    }
  },
};
</script>
